var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#232D43",
  d: "M23.5 21.6q.96 0 1.8.495t1.335 1.335.495 1.8-.495 1.815A3.8 3.8 0 0 1 25.3 28.41q-.84.51-1.8.51t-1.8-.51a3.8 3.8 0 0 1-1.335-1.365 3.57 3.57 0 0 1-.495-1.815q0-.6.06-.81l-8.85-5.16q-1.08.99-2.58.99-.99 0-1.86-.51t-1.38-1.38-.51-1.86.51-1.86 1.38-1.38 1.86-.51q1.5 0 2.58.99l8.79-5.1q-.12-.6-.12-.87 0-.99.51-1.86t1.38-1.38 1.86-.51 1.86.51 1.38 1.38.51 1.86-.51 1.86-1.38 1.38-1.86.51q-1.38 0-2.58-1.05l-8.79 5.16q.12.54.12.84t-.12.9l8.91 5.16q1.08-.93 2.46-.93"
})));
export default SvgShare;